<script lang="ts" setup>
import BreadCrumb from '#components/breadCrumb/BreadCrumb.vue';
import ButtonBase from '#components/elements/button/ButtonBase.vue';
import AppHeader from '#components/layouts/AppLayoutComponents/AppHeader.vue';
import LayoutPage from '#components/layouts/LayoutPage.vue';
import { useLanguage } from '#composables/useLanguage';
import {
  REFERENTIAL_PERIOD,
  type ReferentialPeriodType
} from '#domain/core/filter/components/periodSelector/periodSelector.model';
import {
  DEFAULT_CARREFOUR_REFERENTIAL_INTERVAL,
  type CarrefourReferentialIntervalType,
  type PerimeterFilterViewType
} from '@carrefour-gcs/shared';
import { useRouter } from 'vue-router';
import KpiPerimeterSelection from './components/KpiPerimeterSelection.vue';

const { t } = useLanguage();
const router = useRouter();

const {
  hasTaxButton = true,
  taxonomySelector = { onlyCarrefour: false },
  hasStorePerimeterSelector = true,
  perimeterFilterView = undefined,
  referentialPeriod = REFERENTIAL_PERIOD,
  carrefourReferentialIntervals = DEFAULT_CARREFOUR_REFERENTIAL_INTERVAL,
  hasComparisonPeriod = false
} = defineProps<{
  title: string;
  hasBackButton?: boolean;
  hasTaxButton?: boolean;
  taxonomySelector?: { onlyCarrefour: boolean };
  hasStorePerimeterSelector?: boolean;
  perimeterFilterView?: PerimeterFilterViewType;
  referentialPeriod?: ReferentialPeriodType;
  carrefourReferentialIntervals?: keyof CarrefourReferentialIntervalType;
  hasComparisonPeriod?: boolean;
}>();
</script>

<template>
  <LayoutPage>
    <template #header>
      <AppHeader />
    </template>

    <template #header-content>
      <div class="space-y-2">
        <ButtonBase
          v-if="hasBackButton"
          :label="t('commonLabel.back')"
          variant="default"
          icon-left="arrow-left-circle"
          @click="router.push({ name: 'performance' })"
        />

        <!-- Replace this by a breadcrumb -->
        <BreadCrumb />

        <div class="flex justify-between">
          <div class="flex row gap-4 items-center">
            <slot name="title-start-icon" />
            <h1 class="text-4xl font-bold">{{ title }}</h1>
          </div>
          <slot name="linkButton" />
        </div>
      </div>

      <KpiPerimeterSelection
        :has-tax-button="hasTaxButton"
        :taxonomy-selector="taxonomySelector"
        :has-store-perimeter-selector="hasStorePerimeterSelector"
        :perimeter-filter-view="perimeterFilterView"
        :referential-period="referentialPeriod"
        :carrefour-referential-intervals="carrefourReferentialIntervals"
        :has-comparison-period="hasComparisonPeriod"
      />
    </template>

    <div class="space-y-4">
      <slot />
    </div>
  </LayoutPage>
</template>
